import DownloadAppBtns from './DownloadAppBtns'

export default DownloadAppBtns
